import React from 'react';
import marcio from '../assets/marcio3.jpeg';
import lorenna from '../assets/dra_lorenna.jpeg';
import dominique from '../assets/dra_dominique.jpeg';
import leandro from '../assets/dr_leandro.png';
//import patricia from '../assets/dra_patricia.png';
import alina from '../assets/dra_alina.jpeg';
import katia from '../assets/dra_katia.jpeg';

const members = [
  {
    image: marcio,
    tag: 'Implantodontia',
    name: 'Dr. Marcio do Valle',
    role: 'Responsável técnico - CRO-RJ 26606',
    bio: 'Cirurgião-dentista e fundador da clínica, formado pela Faculdade de Odontologia de Nova Friburgo em 2000. Especialista em Implantodontia pela São Leopoldo Mandic e credenciado para uso da tecnologia de alinhadores ezaligner.',
  },
  {
    image: lorenna,
    tag: 'Clínica geral',
    name: 'Dra. Lorenna Teixeira',
    role: 'Cirurgiã-dentista - CRO-RJ 57482',
    bio: 'Atendimento em clínica geral. Formada em 2024 pela Universidade Estácio de Sá, unidade Recreio dos Bandeirantes.',
  },
  {
    image: leandro,
    tag: 'Cirurgia oral e estética',
    name: 'Dr. Leandro Wantuil',
    role: 'Cirurgião-dentista - CRO-RJ 46054',
    bio: 'Formado desde 2013 pela Faculdade São José. Atualização em cirurgia oral menor pela Acerto em 2018 e habilitação em lentes em resina pelo Instituto Filipe Medeiros em 2021.',
  },
  {
    tag: 'Endodontia',
    name: 'Dra. Larissa Mignone',
    initials: 'LM',
    role: 'Cirurgiã-dentista - CRO-RJ 21662',
    bio: 'Formada em 2018 pela UERJ. Atualizações em endodontia, prótese fixa e removível, ortodontia e especialização em endodontia pelo INCO 25.',
  },
  {
    image: katia,
    tag: 'Clínica geral',
    name: 'Dra. Katia Victoria',
    role: 'Cirurgiã-dentista - CRO-RJ 21742',
    bio: 'Atendimento em clínica geral na equipe Bangu Odonto.',
  },
  {
    image: dominique,
    tag: 'Ortodontia',
    name: 'Dra. Dominique Peniche',
    role: 'Cirurgiã-dentista - CRO-RJ 48696',
    bio: 'Especialista em Ortodontia.',
  },
  {
    image: alina,
    tag: 'Clínica geral',
    name: 'Dra. Alina Maria Braz',
    role: 'Cirurgiã-dentista - CRO-RJ 18238',
    bio: 'Atendimento em clínica geral na equipe Bangu Odonto.',
  },
];

const Team = () => (
  <>
    <div className="divider" id="equipe">
      <span><span className="dot"></span> 03 / Equipe</span>
      <span>Quem atende você</span>
    </div>

    <section className="equipe">
      <div className="equipe-head">
        <h2 className="display">
          Profissionais que conhecem<br />seu <em>nome</em>.
        </h2>
        <p className="aside">
          Mais que currículo: pessoas que gostam do que fazem e de quem atendem.
          Do primeiro atendimento ao acompanhamento final.
        </p>
      </div>

      <div className="team-grid">
        {members.map((m) => (
          <article className="member" key={m.name}>
            <div className="member-photo">
              {m.image ? (
                <img src={m.image} alt={m.name} />
              ) : (
                <div className="member-photo-placeholder" aria-label={`Foto temporária de ${m.name}`}>
                  <span>{m.initials}</span>
                </div>
              )}
              <span className="mem-tag">{m.tag}</span>
            </div>
            <div className="member-name">{m.name}</div>
            <div className="member-role">{m.role}</div>
            <p className="member-bio">{m.bio}</p>
          </article>
        ))}
      </div>
    </section>
  </>
);

export default Team;
